import ReactGA from "react-ga";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import {
  getLocationFailure,
  getLocationSuccess,
  noLocationPermission
} from ".";
import { AppState } from "..";
import { setCenter, setZoom } from "../mapStore";

export const getLocation = (): ThunkAction<
  void,
  AppState,
  null,
  Action<string>
> => {
  return (dispatch, getState) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          dispatch(
            getLocationSuccess({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            })
          );
          dispatch(
            setCenter({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            })
          );
          dispatch(setZoom(14));
          ReactGA.event({
            category: "Location",
            action: "User Located"
          });
        },
        err => {
          dispatch(getLocationFailure("PERMISSION_DENIED"));
          ReactGA.event({
            category: "Location",
            action: "Permission Denied"
          });
        }
      );
    } else {
      dispatch(getLocationFailure("LOCATION_NOT_SUPPORTED"));
      ReactGA.event({
        category: "Location",
        action: "Location Not Supported"
      });
    }
  };
};

export const getLocationIfEnabled = (): ThunkAction<
  void,
  AppState,
  null,
  Action<string>
> => {
  return (dispatch, getState) => {
    try {
      (navigator as any).permissions
        .query({
          name: "geolocation"
        })
        .then((permissionStatus: { state: any }) => {
          switch (permissionStatus.state) {
            case "granted":
              navigator.geolocation.getCurrentPosition(position => {
                dispatch(
                  getLocationSuccess({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                  })
                );
                dispatch(
                  setCenter({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                  })
                );
                dispatch(setZoom(14));
                ReactGA.event({
                  category: "Location",
                  action: "User Located",
                  label: "On Load",
                  nonInteraction: true
                });
              });
              break;
            case "denied":
              dispatch(getLocationFailure("PERMISSION_DENIED"));
              dispatch(setCenter({ lat: 51.512275, lng: -0.116572 }));
              dispatch(setZoom(12));
              ReactGA.event({
                category: "Location",
                action: "Permission Denied",
                label: "On Load",
                nonInteraction: true
              });
              break;
            default:
              dispatch(noLocationPermission());
              dispatch(setCenter({ lat: 51.512275, lng: -0.116572 }));
              dispatch(setZoom(12));
          }
        });
    } catch (e) {
      dispatch(noLocationPermission());
      dispatch(setCenter({ lat: 51.512275, lng: -0.116572 }));
      dispatch(setZoom(12));
      ReactGA.event({
        category: "Location",
        action: "Permissions error",
        label: "On Load",
        nonInteraction: true
      });
    }
  };
};
